import React from "react";
import { Link } from "react-router-dom";
import { Target, Eye, Heart } from "lucide-react";

export default function About() {
  return (
    <div>
      <section className="bg-gradient-to-br from-[#EFF6FF] via-white to-[#FEF7E6] py-16 sm:py-20">
        <div className="container-nx">
          <div className="label-eyebrow">About us</div>
          <h1 className="mt-3 max-w-3xl text-4xl font-bold text-[#0B192C] font-head sm:text-5xl">
            Building a trusted ecosystem for the Vishwakarma community
          </h1>
          <p className="mt-6 max-w-2xl font-display text-lg text-[#2563EB]">
            Connecting People. Creating Progress.
          </p>
        </div>
      </section>

      <section className="section-nx">
        <div className="container-nx grid grid-cols-1 gap-10 lg:grid-cols-3">
          <div className="card-nx p-7">
            <Target className="h-8 w-8 text-[#B8860B]" />
            <h3 className="mt-4 text-xl font-semibold text-[#0B192C] font-head">Our Mission</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-500">
              To empower Vishwakarma entrepreneurs, manufacturers, traders and professionals with a
              trusted platform where they can discover one another, build relationships and grow together.
            </p>
          </div>
          <div className="card-nx p-7">
            <Eye className="h-8 w-8 text-[#B8860B]" />
            <h3 className="mt-4 text-xl font-semibold text-[#0B192C] font-head">Our Vision</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-500">
              A thriving digital ecosystem where every member finds opportunities, partners and support —
              helping the entire community rise together.
            </p>
          </div>
          <div className="card-nx p-7">
            <Heart className="h-8 w-8 text-[#B8860B]" />
            <h3 className="mt-4 text-xl font-semibold text-[#0B192C] font-head">Our Values</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-500">
              Trust, honour and mutual respect. We believe in relationships over transactions and in
              lifting one another through genuine collaboration.
            </p>
          </div>
        </div>

        <div className="container-nx mt-16 text-center">
          <h2 className="heading-2">Ready to be part of something bigger?</h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-slate-500">
            Join a growing network of community business owners and professionals.
          </p>
          <Link to="/register" className="btn-gold mt-8 inline-flex" data-testid="about-join-btn">
            Join the Community
          </Link>
        </div>
      </section>
    </div>
  );
}
